module.exports = __webpack_public_path__ + "static/media/arica_y_parinacota.c1a7cc10.jpg";